import createReactComponent from '../createReactComponent';
export default createReactComponent('rainbow', 'Rainbow', [["path",{"d":"M3 17.5v-2a9 9 0 1 1 18 0v2m-15 0v-2a6 6 0 0 1 12 0v2m-9 0v-2a3 3 0 1 1 6 0v2","key":"svg-0"}]]);